import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Output } from '@angular/core';

export type AlertType = 'success' | 'info' | 'warning' | 'danger';

@Component({
  selector: 'app-alert',
  imports: [CommonModule],
  templateUrl: './alert.component.html',
})
export class AlertComponent {
  message = input<string>('');
  alertType = input<AlertType>('info');
  dismissable = input<boolean>(false);

  @Output() dismiss = new EventEmitter<void>();

  get alertClasses(): { [key: string]: boolean } {
    return {
      alert: true,
      'alert-success': this.alertType() === 'success',
      'alert-info': this.alertType() === 'info',
      'alert-warning': this.alertType() === 'warning',
      'alert-danger': this.alertType() === 'danger',
      'alert-dismissable': this.dismissable(),
    };
  }

  onDismiss() {
    this.dismiss.emit();
  }
}
